import {
  fetchClient
} from "./chunk-K342ITN7.mjs";
import {
  ApiConfig
} from "./chunk-LPIRJEMY.mjs";
import {
  __async
} from "./chunk-DFMI36TU.mjs";

// src/core/wbk/auction/history.ts
import { Exception } from "@wbk/logger";
var getAuctionHistory = (_0) => __async(void 0, [_0], function* ({ slug }) {
  var _a, _b;
  try {
    const data = yield fetchClient({
      baseUrl: (_b = (_a = ApiConfig.config) == null ? void 0 : _a.wbk) == null ? void 0 : _b.socketApi,
      url: `/auctions/${slug}/bids`
    });
    return data.map((sub) => ({
      name: sub.username,
      id: sub.user_id,
      amount: sub.amount,
      date: sub.created_at
    }));
  } catch (error) {
    throw new Exception({
      error,
      name: "getAuctionHistoryException",
      context: { extra: { slug } }
    });
  }
});

export {
  getAuctionHistory
};
//# sourceMappingURL=chunk-7XWBBWMY.mjs.map